<template>
    <div id="home">

        <div class="cv-rounded">
            <div class="w-100 d-md-none">
                <img src="@/assets/banners-clave-verde/optmized/BannerCV600X700px.jpg" alt="Clave Verde" class="img-fluid w-100" />
            </div>
    
            <div class="w-100 d-none d-md-block d-lg-none">
                <img src="@/assets/banners-clave-verde/optmized/BannerCV700X500px.jpg" alt="Clave Verde" class="img-fluid w-100" />
            </div>
    
            <div class="w-100 d-none d-lg-block">
                <img src="@/assets/banners-clave-verde/optmized/BannerCV1920x600px.jpg" alt="Clave Verde" class="img-fluid w-100" />
            </div>
        </div>

        <b-container class="p-3">
            <b-row class="text-center limit-width mt-4 mb-4">
                <b-col cols="12">
                    <h1 class="mb-4">
                        {{ lead }}
                    </h1>
                    <template v-if="!isLogged">
                        <hr>
                        <p>
                            {{ desc }}
                        </p>
                    </template>
                </b-col>
                <b-col cols="12" class="w-100 mb-3 mb-md-0" v-if="!isLogged">
                    <div class="row align-items-center justify-content-center g-3">
                        <b-button variant="primary" size="lg" @click="$refs.accessForm.showModalLogin()">
                            Iniciar sesión
                        </b-button>
                        <lock-button variant="secondary" size="lg" @click="$refs.accessForm.showModalRegister()">
                            Crear cuenta
                        </lock-button>
                    </div>
                </b-col>
                <b-col cols="12" class="w-100 mb-3 mb-md-0" v-else>
                    <div class="row align-items-center justify-content-center g-3">
                        <b-button variant="primary" size="lg" @click="$router.push({ name: 'MyAccount'})">
                            Ir a mi cuenta
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <access-form ref="accessForm"  v-if="!isLogged" />

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'Home',
    props: {
        lead: {
            type: String,
            default: 'Bienvenido a Clave Verde'
        },
        desc: {
            type: String,
            default: 'Para empezar a usar, debes iniciar sesión o crear tu cuenta'
        },
        header: {
            type: String,
            default: 'Inicio'
        }
    },
    computed: {
        ...mapGetters(['isLogged'])
    }
};
</script>